import { gsap } from "gsap";


    
export function initLoader() {
    let overlay = document.querySelector('.overlay-loader')
    gsap.timeline()
    .to(overlay, { duration: 0.4, opacity: 0, delay: 1 })   // Animate in (fade out overlay)
    .to(overlay, { duration: 0.1, bottom: '100%', delay: 0.5 }); // Animate out
}